import { IProductRow } from "models/table";
import { productColors } from "utils/constants/colors";

export default function ProductNameTableCell({ productId, productName }: IProductRow) {
  const className = `name bg-${productColors[productId] || "none"}`;
  return <span className={className}>{productName}</span>;
}
